"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var lazy = function lazy(f) {
  return function (start, sink) {
    if (start === 0) {
      sink(0, function () {});
      sink(1, f());
      sink(2);
    }
  };
};

var _default = lazy;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/callbag-lazy/index.js
// module id = 632
// module chunks = 0